export const LOAD_PLAYER_STATS = "LOAD_PLAYER_STATS";
export const LOAD_PLAYER_STATS_SUCCESS = "LOAD_PLAYER_STATS_SUCCESS";
export const LOAD_PLAYER_STATS_FAILED = "LOAD_PLAYER_STATS_FAILED";

export const LOAD_PLAYER_MATCHES = "LOAD_PLAYER_MATCHES";
export const LOAD_PLAYER_MATCHES_SUCCESS = "LOAD_PLAYER_MATCHES_SUCCESS";
export const LOAD_PLAYER_MATCHES_FAILED = "LOAD_PLAYER_MATCHES_FAILED";